export default __webpack_public_path__ + "static/media/coin-beige.e734d323.png";